import {fetch} from "utils/dataAccess";

export default async function ship(order, values, orderId= null)  {
    const response = await fetch(`/orders/${order?.id ?? orderId}/ship`, {
        method: "POST",
        body: JSON.stringify(values),
    });

    return await response.json();
}
